;(function ($, window) {
  'use strict'

  // setup a shared namespace, if needed
  window.GCO = window.GCO || {}

  window.GCO.incentiveWizard = (function () {
    const $form = $('#form--wizard')

    function validateAnswer ($fs) {
      let selected
      const fsId = $fs.attr('data-fs')
      // console.log('validating ...', fsId, $fs)
      switch (fsId) {
        case '1':
          selected = $('[name="county"] option:selected').val()
          // console.log('county', selected)
          if (!selected || selected === 'Other') {
            return '1-ineligible'
          }
          return 2
        case '2':
          selected = $('[name="hasPoBox"]:checked').val()
          // console.log('hasPoBox', selected)
          if (!selected || selected === 'yes') {
            return '2-ineligible'
          }
          return 3
        case '3':
          selected = $('[name="drivesAlone"]:checked').val()
          // console.log('drivesAlone', selected)
          if (selected === 'yes') {
            return '4a'
          }
          return '4b'
        case '4a':
          selected = $('[name="alreadyParticipated"]:checked').val()
          // console.log('alreadyParticipated', selected)
          if (selected === 'no') {
            return 'gimme-five'
          }
          return '4a-ineligible'
        case '4b':
          selected = $('[name="alreadyCarpool"]:checked').val()
          // console.log('alreadyCarpool', selected)
          if (selected === 'no') {
            return 'cash-25'
          }
          return 'gas-card'
      }
    }

    function updateStepper (currentStepNum) {
      // console.log('updatestepper', currentStepNum)
      let cur = parseInt(currentStepNum, 10)

      $('#stepper li').each((i, el) => {
        let step = i + 1
        // console.log('step', i, step, cur)
        if (step < cur) {
          $(el).addClass('active completed')
        } else if (step === cur) {
          $(el).removeClass('completed').addClass('active')
        } else {
          $(el).removeClass('active')
        }
      })
      // activate next step on progressbar using the index of $nextFs
      // $('#stepper li').eq($('fieldset').index($nextFs)).addClass('active')
    }

    function verificationForm () {
      let $currentFs, $nextFs, $previousFs // fieldsets
      let left, opacity, scale // fieldset properties which we will animate
      let animating, stepsUpdated // flags to prevent quick multi-click glitches

      $('.nice-select').niceSelect()

      $form.find('.next').on('click', function () {
        if (animating) return false
        animating = true
        stepsUpdated = false

        $currentFs = $(this).closest('fieldset')
        let nextFsId = $(this).attr('data-fs-target')
        if (!nextFsId) {
          nextFsId = validateAnswer($currentFs)
        }
        $nextFs = $form.find(`[data-fs="${nextFsId}"]`)

        // show the next fieldset
        $nextFs.show()
        // hide the current fieldset with style
        $currentFs.animate({
          opacity: 0
        }, {
          progress: function (animation, progress, remainingMs) {
            // console.log('progress', progress, remainingMs)
            if (progress > 0.5 && !stepsUpdated) {
              stepsUpdated = true
              updateStepper($nextFs.attr('data-step'))
            }
          },
          step: function (now, mx) {
            // as the opacity of $currentFs reduces to 0 - stored in "now"
            // 1. scale $currentFs down to 80%
            scale = 1 - (1 - now) * 0.2
            // 2. bring $nextFs from the right(50%)
            left = (now * 50) + '%'
            // 3. increase opacity of $nextFs to 1 as it moves in
            opacity = 1 - now
            $currentFs.css({
              'transform': 'scale(' + scale + ')',
              'position': 'absolute'
            })
            $nextFs.css({
              'left': left,
              'opacity': opacity
            })
          },
          duration: 800,
          complete: function () {
            $currentFs.hide().css({ transform: 'scale(1)' })
            animating = false
          },
          // this comes from the custom easing plugin
          easing: 'easeInOutBack'
        })
      })

      $form.find('.prev').on('click', function () {
        if (animating) return false
        animating = true
        stepsUpdated = false

        $currentFs = $(this).closest('fieldset')
        const prevFsId = $(this).attr('data-fs-target')
        console.log('prevFsId', prevFsId)
        $previousFs = $form.find(`[data-fs="${prevFsId}"]`)

        // show the previous fieldset
        $previousFs.show()
        // hide the current fieldset with style
        $currentFs.animate({
          opacity: 0
        }, {
          progress: function (animation, progress, remainingMs) {
            // console.log('progress', progress, remainingMs)
            if (progress > 0.5 && !stepsUpdated) {
              stepsUpdated = true
              updateStepper($previousFs.attr('data-step'))
            }
          },
          step: function (now) {
            // as the opacity of $currentFs reduces to 0 - stored in "now"
            // 1. scale $previousFs from 80% to 100%
            scale = 0.8 + (1 - now) * 0.2
            // 2. take $currentFs to the right(50%) - from 0%
            left = ((1 - now) * 50) + '%'
            // 3. increase opacity of $previousFs to 1 as it moves in
            opacity = 1 - now
            $currentFs.css({
              'left': left
            })
            $previousFs.css({
              'transform': 'scale(' + scale + ')',
              'opacity': opacity
            })
          },
          duration: 800,
          complete: function () {
            $currentFs.hide().css({ transform: 'scale(1)' })
            animating = false
          },
          // this comes from the custom easing plugin
          easing: 'easeInOutBack'
        })
      })

      $('.submit').on('click', function () {
        return false
      })
    }

    function init () {
      if ($form.length) {
        verificationForm()
      }
    }

    return {
      init: init
    }
  }())

  $(document).ready(GCO.incentiveWizard.init)
}(jQuery, window))
